import { render, staticRenderFns } from "./product_index.vue?vue&type=template&id=c7e3895a&scoped=true&"
import script from "./product_index.vue?vue&type=script&lang=js&"
export * from "./product_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e3895a",
  null
  
)

export default component.exports